export default {
      MyContactsHistory: 'الطلب المغلق|طلباتي المغلقة',
      MyContactsHistory_no_body: 'طلب مغلق',
};
